enum ThemeMotionEaseEnum {
	easy = 'easy',
	expressive = 'expressive',
	enter = 'enter',
	exit = 'exit',
	bob = 'bob',
	linear = 'linear'
}

export default ThemeMotionEaseEnum;
